module.exports = __webpack_public_path__ + "images/product-icon-10-years-warranty.5922f6.svg";